export const SET_SETTING = 'EVENT/SET_SETTING'
export const SET_SETTINGINTERACTION = 'EVENT/SET_SETTINGINTERACTION'
export const SET_SYMPLA = 'EVENT/SET_SYMPLA'
export const SET_ZOOM = 'EVENT/SET_ZOOM'
export const SET_NOTIFICATION = 'EVENT/SET_NOTIFICATION'
